import { render, staticRenderFns } from "./NsHeaderTop.vue?vue&type=template&id=5e6ac6ef&scoped=true"
import script from "./NsHeaderTop.vue?vue&type=script&lang=js"
export * from "./NsHeaderTop.vue?vue&type=script&lang=js"
import style0 from "./NsHeaderTop.vue?vue&type=style&index=0&id=5e6ac6ef&prod&lang=scss"
import style1 from "./NsHeaderTop.vue?vue&type=style&index=1&id=5e6ac6ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b5e12a4b1c1729405afdf532a227c02e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6ac6ef",
  null
  
)

export default component.exports